export default "__VITE_ASSET__f8c0e408__"